import React from "react";
import { Link } from "react-router-dom";
import style from "./error.module.css";
const ErrrorPage = () => {
  return (
    <div className={style.error_container}>
      <div className={style.error_header_text}>Oops!</div>
      <div className={style.error_content_text}>
        We can't seem to find the page you're looking for.
      </div>
      <div className={style.error_content_link_text}>
        To login please click here <Link to="/">Login</Link>
      </div>
    </div>
  );
};

export default ErrrorPage;
